// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"12":"profiler","777":"recorder"}[chunkId] + "-" + {"12":"b03faf814a9b009aba06","777":"a00382fc275ac6d47214"}[chunkId] + ".js";
};